import * as Schema from "effect/Schema";
import { Identifier, Revision, SafeInteger, TimeMs } from "@linempo/kernel";
/** v1 admission limits, not a claim that these configurations passed browser acceptance. */
export const ExportSettings = Schema.Struct({
    width: Schema.Literals([1280, 1920]),
    height: Schema.Literals([720, 1080]),
    fps: Schema.Literal(30),
    container: Schema.Literal("mp4"),
    codec: Schema.Literal("avc"),
    bitrate: SafeInteger.check(Schema.isGreaterThanOrEqualTo(1_000_000), Schema.isLessThanOrEqualTo(30_000_000)),
    keyframeIntervalFrames: SafeInteger.check(Schema.isGreaterThan(0), Schema.isLessThanOrEqualTo(300)),
    hardwareAcceleration: Schema.Literals(["prefer-hardware", "prefer-software", "no-preference"]),
}).check(Schema.makeFilter((settings) => settings.width * 9 === settings.height * 16 || "v1 exports use a 16:9 frame"));
export const DEFAULT_EXPORT_SETTINGS = Object.freeze({
    width: 1920, height: 1080, fps: 30, container: "mp4", codec: "avc", bitrate: 12_000_000,
    keyframeIntervalFrames: 60, hardwareAcceleration: "prefer-hardware",
});
export const MAX_EXPORT_DURATION_MS = 600_000;
export const ArtifactDescriptor = Schema.Struct({
    id: Identifier,
    jobId: Identifier,
    projectRevision: Revision,
    fileName: Schema.String,
    mimeType: Schema.Literal("video/mp4"),
    byteLength: SafeInteger.check(Schema.isGreaterThan(0)),
    width: SafeInteger.check(Schema.isGreaterThan(0)),
    height: SafeInteger.check(Schema.isGreaterThan(0)),
    fps: Schema.Literal(30),
    frameCount: SafeInteger.check(Schema.isGreaterThan(0)),
    durationUs: SafeInteger.check(Schema.isGreaterThan(0)),
});
/** Frame timestamps are derived from the index, never by accumulating rounded durations. */
export function frameCount(durationMs, fps = 30) {
    Schema.decodeUnknownSync(TimeMs)(durationMs);
    Schema.decodeUnknownSync(Schema.Literal(30))(fps);
    if (durationMs <= 0 || durationMs > MAX_EXPORT_DURATION_MS)
        throw new RangeError("export duration must be within (0, 600000] milliseconds");
    return Math.ceil(durationMs * fps / 1000);
}
export function frameTiming(index, fps = 30) {
    Schema.decodeUnknownSync(SafeInteger)(index);
    Schema.decodeUnknownSync(Schema.Literal(30))(fps);
    if (index >= MAX_EXPORT_DURATION_MS * fps / 1000)
        throw new RangeError("frame index exceeds v1 export duration");
    const timestampUs = Math.round(index * 1_000_000 / fps);
    return { timeMs: index * 1000 / fps, timestampUs, durationUs: Math.round((index + 1) * 1_000_000 / fps) - timestampUs };
}
